import { ProjectRegisterGroupBy } from "./projectRegisterTableUtils";

export type ProjectRegisterGroupableFields = {
  measureType?: string | null;
  measureCategory?: string | null;
};

type ProjectRegisterGroupLabelSource = ProjectRegisterGroupableFields & {
  name?: string | null;
};

const getNormalizedLabel = (value: string | null | undefined) => {
  const normalizedValue = value?.trim();

  return normalizedValue && normalizedValue.length > 0
    ? normalizedValue
    : "Unspecified";
};

export const toProjectRegisterNumber = (
  value: number | string | null | undefined
) => {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : 0;
  }

  if (typeof value === "string") {
    const normalizedValue = value.trim();
    if (normalizedValue === "") {
      return 0;
    }

    const parsedValue = Number(normalizedValue);
    return Number.isFinite(parsedValue) ? parsedValue : 0;
  }

  return 0;
};

export const getProjectRegisterGroupLabel = (
  item: ProjectRegisterGroupLabelSource,
  groupBy: ProjectRegisterGroupBy
) => {
  if (groupBy === "Type") {
    return getNormalizedLabel(item.measureType);
  }

  if (groupBy === "Category") {
    return getNormalizedLabel(item.measureCategory);
  }

  return getNormalizedLabel(item.name);
};